import { useState, useEffect } from 'react';
import { AppConfigSet, loadAppSetUp } from '@gjensidige/se-content-helpers';

interface UseAppTextsReturn {
  appTexts: Record<string, string>;
}

const fetchTextsFromAPI = async (): Promise<Record<string, string>> => {
  const configSet = [AppConfigSet.GENERIC_ILLUSTRATION];

  try {
    const staticData = await loadAppSetUp('calculation-widget-se', configSet);

    const mergedTexts = configSet.reduce((acc, _, index) => {
      return { ...acc, ...(staticData[index] || {}) };
    }, {});

    return mergedTexts;
  } catch (err) {
    console.error('Failed to load app texts:', err);
    throw err;
  }
};

export const useAppTexts = (): UseAppTextsReturn => {
  const [appTexts, setAppTexts] = useState<Record<string, string>>({});

  const fetchAppTexts = async () => {
    try {
      const texts = await fetchTextsFromAPI();
      setAppTexts(texts)
    } catch (err) {
      console.error('Failed to load app texts:', err);
    }
  };

  useEffect(() => {
    fetchAppTexts();
  }, []);

  return {
    appTexts,
  };
};